import moment from "moment";

const currencyFormat = (num) => {
  return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

const dateFormat = (rawDate) => {
  return moment(rawDate).locale("es").format("YYYY-MM-DD");
};

export { currencyFormat as currencyPipe, dateFormat as datePipe };
